import Utils from '../../utils/Utils';
import { Dates } from '../../packages/dates';
import {
  getMinutesToRetryInsertingEpg,
  getDaysToInsertEpg,
  getMinimumFutureDaysAvailableEpg,
  getMinimumPastDaysAvailableEpg,
  getDaysBeforeTodayToInsert,
  getMinutesToWakeUp,
  getPureEpgUrl,
  showEpgUpdateProgress,
  isAndroidDevice,
  getUpdateEpgBlackList,
  isHourBetweenRange,
  getRandomInt,
  convertMinutesToMilliseconds,
  getInsertingTriesLimit,
  getMomentNowFromSpecificHour,
  getHourRange,
  getOnEpgNoSuccessTriesLimit,
  getOnEpgNoSuccessTimeout
} from '../helpers/Utils';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import DashboardTracker from '../../utils/trackers/DashboardTracker';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import AndroidFeeder from './AndroidFeeder';
import JsFeeder from './JsFeeder';
import NpvrUploader from '../../AAF/Npvr/NpvrUploader';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import settings from '../../devices/all/settings';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import logger from 'src/utils/logger/logger';
/**
 * @class EpgFeederManager: to fetch, insert, update, drop the persistent data bases of epg
 */

/** Constants from apa/metadata */

let instance = null;

class EpgFeederManager {
  constructor() {
    if (!instance) {
      instance = this;
      this.N_MINUTES = getMinutesToRetryInsertingEpg().minutes;
      this.N_DAYS = getDaysToInsertEpg().days;
      this.MINIMUM_FUTURE_DAYS_AVAILABLE_EPG = getMinimumFutureDaysAvailableEpg().days;
      this.MINIMUM_PAST_DAYS_AVAILABLE_EPG = getMinimumPastDaysAvailableEpg().days;
      this.DAYS_BEFORE_TODAY_TO_INSERT = getDaysBeforeTodayToInsert().days;
      this.MINUTES_TO_WAKE_UP = getMinutesToWakeUp().minutes;
      this.INSERTING_TRIES_LIMIT = getInsertingTriesLimit().limit;
      this.HOUR_RANGE = getHourRange().hours;
      this.ON_EPG_NO_SUCCESS_TIMEOUT = getOnEpgNoSuccessTimeout().minutes;
      this.ON_EPG_NO_SUCCESS_TRIES_LIMIT = getOnEpgNoSuccessTriesLimit().limit;
      this._daysInHour = this.N_DAYS * 24;
      this._nodeId = '';
      this._idTimerInserting = null;
      this._idTimerWakeUp = null;
      this._idTimerCheckTimeoutOnEpgSuccess = null;
      this._isInserting = false;
      this._insertingFailedNumber = 0;
      this._onEpgSuccessFailedNumber = 0;
      this.tracker = new DashboardTracker();
      this.feeder = settings.use_dexie ? new JsFeeder() : new AndroidFeeder();
      this.init();
      this.lastEpgDBStartTimeUnix = null;
      this.lastEpgDBEndTimeUnix = null;
    }
    return instance;
  }

  init() {
    this.onEpgError = this.onEpgError.bind(this);
    this.onEpgSuccess = this.onEpgSuccess.bind(this);
    document.removeEventListener('onEpgError', this.onEpgError);
    document.addEventListener('onEpgError', this.onEpgError);
    document.removeEventListener('onEpgSuccess', this.onEpgSuccess);
    document.addEventListener('onEpgSuccess', this.onEpgSuccess);
  }

  cleanup() {
    if (this._idTimerInserting) {
      clearTimeout(this._idTimerInserting);
      this._idTimerInserting = null;
    }
    if (this._idTimerWakeUp) {
      clearInterval(this._idTimerWakeUp);
      this._idTimerWakeUp = null;
    }
    if (this._idTimerCheckTimeoutOnEpgSuccess) {
      clearInterval(this._idTimerCheckTimeoutOnEpgSuccess);
      this._idTimerCheckTimeoutOnEpgSuccess = null;
    }
    document.removeEventListener('onEpgError', this.onEpgError);
    document.removeEventListener('onEpgSuccess', this.onEpgSuccess);
  }

  getAllChannelsFilter() {
    return this._nodeId;
  }

  setAllChannelsFilter(nodeId) {
    this._nodeId = nodeId;
  }

  removeEpgDBStartTime() {
    DeviceStorage.unsetItem('_epgDBStartTime_');
  }

  removeEpgDBEndTime() {
    DeviceStorage.unsetItem('_epgDBEndTime_');
  }

  setEpgDBStartTime(startTime) {
    if (startTime) {
      DeviceStorage.setItem('_epgDBStartTime_', `${startTime}`);
      DeviceStorage.setItem('_epgDBStartTime_temp_', `${startTime}`);
    }
  }

  setEpgDBEndTime(endTime) {
    if (endTime) {
      DeviceStorage.setItem('_epgDBEndTime_', `${endTime}`);
      DeviceStorage.setItem('_epgDBEndTime_temp_', `${endTime}`);
    }
  }

  setEpgDBStartTimeTemp(startTime) {
    if (startTime) {
      DeviceStorage.setItem('_epgDBStartTime_temp_', `${startTime}`);
    }
  }

  setEpgDBEndTimeTemp(endTime) {
    if (endTime) {
      DeviceStorage.setItem('_epgDBEndTime_temp_', `${endTime}`);
    }
  }

  getEpgDBStartTime(includeTemp = false) {
    let startTime = DeviceStorage.getItem('_epgDBStartTime_') || null;
    if (startTime) {
      return startTime;
    } else {
      if (includeTemp) {
        return DeviceStorage.getItem('_epgDBStartTime_temp_') || null;
      }
    }
    return null;
  }

  getEpgDBEndTime(includeTemp = false) {
    let endTime = DeviceStorage.getItem('_epgDBEndTime_') || null;
    if (endTime) {
      return endTime;
    } else {
      if (includeTemp) {
        return DeviceStorage.getItem('_epgDBEndTime_temp_') || null;
      }
    }
    return null;
  }

  async calculateRanges() {
    try {
      let now = Utils.now(true),
        nowDay = now.date(),
        initialMoment = null,
        momentAux = null;
      let momentFrom = null,
        momentTo = null,
        date_from = null,
        date_to = null,
        node_id = null,
        epgUrl = null;
      initialMoment = getMomentNowFromSpecificHour('00:00:00').subtract(
        this.DAYS_BEFORE_TODAY_TO_INSERT,
        'd'
      );
      momentAux = new Dates(initialMoment);
      logger.debug(
        '[EpgFeederManager] calculateRanges initial Moment',
        initialMoment.format('YYYY-MM-DD-HH:mm:ss')
      );
      let rangesInHour = this._daysInHour / this.HOUR_RANGE;
      let urlsArray = [];
      const filters = await new ChannelSingleton().getFilters(); //wait to get all filters from ChannelSingleton
      if (filters[0] && filters[0].id) {
        this.setAllChannelsFilter(filters[0].id);
      }
      if (!this.getAllChannelsFilter()) {
        return new Promise(resolve => resolve(false));
      }
      node_id = this.getAllChannelsFilter();
      for (let i = 0; i < rangesInHour; i++) {
        momentFrom = new Dates(momentAux);
        momentTo = new Dates(momentAux.add(this.HOUR_RANGE, 'h'));
        date_from = momentFrom.format('YYYYMMDDHHmmss');
        date_to = momentTo.format('YYYYMMDDHHmmss');
        logger.debug(
          `[EpgFeederManager] calculateRanges range ${i}: ${date_from}-${date_to}`
        );
        epgUrl = getPureEpgUrl({
          date_from,
          date_to,
          filter_inactive: 0,
          from: 0,
          quantity: 200,
          node_id
        });
        urlsArray.push(epgUrl);
      }
      logger.debug('[EpgFeederManager] calculateRanges urlsArray', urlsArray);
      return new Promise(resolve =>
        resolve({
          urlsArray,
          epgDBStartTime: initialMoment,
          epgDBEndTime: momentAux
        })
      );
    } catch (e) {
      logger.error('[EpgFeederManager] calculateRanges catch e', e);
      return new Promise(resolve =>
        resolve({
          urlsArray: [],
          epgDBStartTime: null,
          epgDBEndTime: null
        })
      );
    }
  }

  async checkAvailableDB() {
    //return new Promise(resolve=>resolve(true)); // NO DESCOMENTAR ESTO PARA PRODUCCION, SOLO PARA PRUEBAS
    let epgDBStartTime = this.getEpgDBStartTime();
    let epgDBEndTime = this.getEpgDBEndTime();
    logger.debug(
      '[EpgFeederManager] checkAvailableDB epgDBStartTime',
      epgDBStartTime,
      ' epgDBEndTime',
      epgDBEndTime
    );
    if (epgDBStartTime && epgDBEndTime) {
      epgDBStartTime = parseInt(epgDBStartTime);
      epgDBEndTime = parseInt(epgDBEndTime);
      const unixNow = Utils.now(true).unix();
      const now = Utils.now(true);
      if (epgDBEndTime < unixNow) {
        logger.debug(
          '[EpgFeederManager] checkAvailableDB not available db due to epgDBEndTime<unixNow'
        );
        return new Promise(resolve => resolve(false));
      } else {
        const epgDBEndTimeMoment = new Dates().unix(epgDBEndTime);
        const epgDBStartTimeMoment = new Dates().unix(epgDBStartTime);
        let futureDays = epgDBEndTimeMoment.diff(now, 'days', true);
        let pastDays = now.diff(epgDBStartTimeMoment, 'days', true);
        if (
          pastDays <= this.MINIMUM_PAST_DAYS_AVAILABLE_EPG ||
          futureDays <= this.MINIMUM_FUTURE_DAYS_AVAILABLE_EPG
        ) {
          logger.debug('[EpgFeederManager] checkAvailableDB not available epg');
          return new Promise(resolve => resolve(false));
        }
      }
      return new Promise(resolve => resolve(true));
    }
    return new Promise(resolve => resolve(false));
  }

  async boot() {
    //showEpgUpdateProgress('spinner',1);
    const epgAvailable = await this.checkAvailableDB();
    logger.debug('[EpgFeederManager] boot epgAvailable?', epgAvailable);
    if (epgAvailable) {
      showEpgUpdateProgress('spinner', 50);
      this.wakeUp();
      this.updateRecordings();
    } else {
      await this.inserting('spinner');
    }
    showEpgUpdateProgress('spinner', 100);
    return new Promise(resolve => resolve(true));
  }

  onEpgError(e) {
    logger.debug('[EpgFeederManager] onEpgError Failed Number', this._insertingFailedNumber);
    logger.debug('[EpgFeederManager] onEpgError Tries Limit', this.INSERTING_TRIES_LIMIT);
    if (this._insertingFailedNumber < this.INSERTING_TRIES_LIMIT) {
      const millisecondsToWakeUp = convertMinutesToMilliseconds(this.N_MINUTES);
      this.insertingAfterMilliseconds(millisecondsToWakeUp);
      this._insertingFailedNumber++;
      logger.debug(
        '[EpgFeederManager] onEpgError inserting fail another insert try in ',
        this.N_MINUTES,
        ' minutes'
      );
    } else {
      this._insertingFailedNumber = 0;
    }
    this.removeEpgDBStartTime();
    this.removeEpgDBEndTime();
    this.tracker.trackEpg('EPG_ERROR', 1, {
      msg: `an error occured while inserting`,
      stackTrace: 'epg-update'
    });
  }

  startTimeoutOnEpgSuccess() {
    const milliseconds = convertMinutesToMilliseconds(this.ON_EPG_NO_SUCCESS_TIMEOUT);
    if (!this._idTimerCheckTimeoutOnEpgSuccess) {
      this._idTimerCheckTimeoutOnEpgSuccess = setInterval(
        () => this.checkTimeoutOnEpgSuccess(),
        milliseconds
      );
    }
  }

  checkTimeoutOnEpgSuccess() {
    logger.debug(
      '[EpgFeederManager] checkTimeoutOnEpgSuccess onEpgSuccessFailedNumber:' +
      this._onEpgSuccessFailedNumber +
      ', limit:' +
      this.ON_EPG_NO_SUCCESS_TRIES_LIMIT
    );
    if (this._onEpgSuccessFailedNumber < this.ON_EPG_NO_SUCCESS_TRIES_LIMIT) {
      if (this.getEpgDBStartTime() && this.getEpgDBEndTime()) {
        logger.debug(
          '[EpgFeederManager] checkTimeoutOnEpgSuccess EpgDBStartTime, EpgDBEndTimeis is defined clear interval'
        );
        clearInterval(this._idTimerCheckTimeoutOnEpgSuccess);
        this._idTimerCheckTimeoutOnEpgSuccess = null;
        this._onEpgSuccessFailedNumber = 0;
      } else {
        logger.debug(
          '[EpgFeederManager] checkTimeoutOnEpgSuccess EpgDBStartTime, EpgDBEndTimeis undefined, lets inserting'
        );
        this.inserting();
        logger.debug('[EpgFeederManager] checkTimeoutOnEpgSuccess another try');
        this._onEpgSuccessFailedNumber++;
      }
    } else {
      logger.debug('[EpgFeederManager] checkTimeoutOnEpgSuccess tries limit, clear interval');
      clearInterval(this._idTimerCheckTimeoutOnEpgSuccess);
      this._idTimerCheckTimeoutOnEpgSuccess = null;
      this._onEpgSuccessFailedNumber = 0;
    }
  }

  onEpgSuccess(e) {
    logger.debug('[EpgFeederManager] onEpgSuccess');
    this.setEpgDBStartTime(this.lastEpgDBStartTimeUnix);
    this.setEpgDBEndTime(this.lastEpgDBEndTimeUnix);
    this.tracker.trackEpg('EPG_SUCCESS', 1, {
      msg: `epg update success, last Epg DB Start Time Unix: ${this.lastEpgDBStartTimeUnix}, last Epg DB End Time Unix: ${this.lastEpgDBEndTimeUnix}`,
      stackTrace: 'epg-update'
    });
    this.updateRecordings();

    // Para cuando estemos en local con dexie,
    // que PC de live de canal sin TS se actualice
    if(settings.use_dexie) {
      document.dispatchEvent(
        new CustomEvent('onEpgSuccessPC', {
          detail: {}
        })
      );
    }
  }

  async updateRecordings() {
    if (NpvrUtil.recordingIconEnable().enable) {
      await NpvrUploader.getRecordings();
      await NpvrUploader.updateLocalRecordings();
    }
  }

  async resetEpgDataFromWakeUp(){
      let continueFlow = false;
      if (EpgPersistence.isDatabaseDataSource()) {
        continueFlow = await new ChannelSingleton().reloadEpgMenuEpgLineUp();
      }
      /*
      return new Promise((resolve)=>{
        resolve(continueFlow)
      });
      */
  }

  async inserting(updateLoadingMessage = '') {
    try {
      if (this._isInserting) {
        return new Promise(resolve => resolve(false));
      }
      this.tracker.trackEpg('EPG_INSERTING', 1, {
        msg: `epg update time, trying to insert`,
        stackTrace: 'epg-update'
      });
      this._isInserting = true;
      this.removeEpgDBStartTime();
      this.removeEpgDBEndTime();
      const { urlsArray, epgDBStartTime, epgDBEndTime } = await this.calculateRanges();
      this.lastEpgDBStartTimeUnix = epgDBStartTime.unix();
      this.lastEpgDBEndTimeUnix = epgDBEndTime.unix();
      this.startTimeoutOnEpgSuccess();
      const updateResult = await this.feeder.updateOfflineEpg(
        urlsArray,
        updateLoadingMessage
      );
      if (updateResult) {
        this.setEpgDBStartTimeTemp(this.lastEpgDBStartTimeUnix);
        this.setEpgDBEndTimeTemp(this.lastEpgDBEndTimeUnix);
        logger.debug('[EpgFeederManager] inserting inserted done!');
        logger.debug('[EpgFeederManager] inserting epgDBStartTime: ' + epgDBStartTime);
        logger.debug('[EpgFeederManager] inserting epgDBEndTime: ' + epgDBEndTime);
        this.wakeUp();

        if(settings.use_dexie){
          this.onEpgSuccess();
        }
        this._isInserting = false;
      } else {
        this._isInserting = false;
        logger.debug(
          '[EpgFeederManager] inserting Failed Number',
          this._insertingFailedNumber
        );
        logger.debug('[EpgFeederManager] inserting Tries Limit', this.INSERTING_TRIES_LIMIT);
        if (this._insertingFailedNumber < this.INSERTING_TRIES_LIMIT) {
          const millisecondsToWakeUp = convertMinutesToMilliseconds(this.N_MINUTES);
          this.insertingAfterMilliseconds(millisecondsToWakeUp);
          this._insertingFailedNumber++;
          logger.debug(
            '[EpgFeederManager] inserting fail another insert try in ',
            this.N_MINUTES,
            ' minutes'
          );
        } else {
          this._insertingFailedNumber = 0;
        }
      }
    } catch (e) {
      this.tracker.trackEpg('EPG_ERROR', 1, {
        msg: `an error occured while inserting`,
        stackTrace: 'epg-update'
      });
      logger.error('[EpgFeederManager] inserting catch e', e);
      this._isInserting = false;
      return new Promise(resolve => resolve(false));
    }
  }

  wakeUp() {
    const millisecondsToWakeUp = convertMinutesToMilliseconds(this.MINUTES_TO_WAKE_UP);
    logger.debug('[EpgFeederManager] wakeUp millisecondsToWakeUp: ' + millisecondsToWakeUp);
    this.tracker.trackEpg('EPG_WAKE_UP', 1, {
      msg: `wake up setted, epg is going to update in ${millisecondsToWakeUp} milliseconds`,
      stackTrace: 'epg-update'
    });
    if (millisecondsToWakeUp > 0) {
      logger.debug('[EpgFeederManager] wakeUp setted');
      if (!this._idTimerWakeUp) {
        this._idTimerWakeUp = setInterval(() => {
          this.verifyBlackListToInsert();
        }, millisecondsToWakeUp);
      }
    }
  }

  async verifyBlackListToInsert() {
    const blackList = getUpdateEpgBlackList().blackList;
    if (blackList && Array.isArray(blackList)) {
      logger.debug(
        '[EpgFeederManager] verifyBlackListToInsert blackList ' + JSON.stringify(blackList)
      );
      const nowMoment = Utils.now(true);
      const nowHour = nowMoment.format('HH:mm');
      let timeToInsert = null;
      logger.debug('[EpgFeederManager] verifyBlackListToInsert nowHour ' + nowHour);
      let shouldWakeUp = true;
      for (let i = 0; i < blackList.length; i++) {
        logger.debug(
          '[EpgFeederManager] verifyBlackListToInsert item to verify',
          blackList[i]
        );
        if (isHourBetweenRange(nowHour, blackList[i])) {
          shouldWakeUp = false;
          timeToInsert = blackList[i].finalLimit;
          break;
        }
      }
      logger.debug('[EpgFeederManager] shouldWakeUp ' + shouldWakeUp);
      logger.debug('[EpgFeederManager] verifyBlackListToInsert timeToInsert ' + timeToInsert);
      if (shouldWakeUp) {
        await this.resetEpgDataFromWakeUp();
        this.inserting();
      } else {
        const auxMoment = getMomentNowFromSpecificHour(`${timeToInsert}:00`);
        logger.debug(
          '[EpgFeederManager] verifyBlackListToInsert finalLimit ' +
          auxMoment.format('DD/MM/YYYY HH:mm:ss')
        );
        const unixMoment = auxMoment.unix();
        const unixNow = Utils.now(true).unix();
        const seconds = (unixMoment - unixNow) * 1000;
        logger.debug('[EpgFeederManager] verifyBlackListToInsert seconds ' + seconds);
        logger.debug('[EpgFeederManager] verifyBlackListToInsert unixNow ' + unixNow);
        logger.debug('[EpgFeederManager] verifyBlackListToInsert unixMoment ' + unixMoment);
        const randomMinutes = getRandomInt(1, 10);
        logger.debug(
          '[EpgFeederManager] verifyBlackListToInsert randomMinutes ' + randomMinutes
        );
        const randomMilliseconds = convertMinutesToMilliseconds(randomMinutes);
        logger.debug(
          '[EpgFeederManager] verifyBlackListToInsert randomMilliseconds ' +
          randomMilliseconds
        );
        const millisecondsToInserting = seconds + randomMilliseconds;
        logger.debug(
          '[EpgFeederManager] verifyBlackListToInsert millisecondsToInserting ' +
          millisecondsToInserting
        );
        this.insertingAfterMilliseconds(millisecondsToInserting);
      }
    }
  }

  insertingAfterMilliseconds(milliseconds) {
    this._idTimerInserting = setTimeout(() => {
      logger.debug('[EpgFeederManager] inserting After Milliseconds', milliseconds);
      this.inserting();
      this._idTimerInserting = null;
    }, milliseconds);
  }
}
export default EpgFeederManager;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/feeders/EpgFeederManager.js